import { Button, IconButton, Tooltip, forwardRef } from '@chakra-ui/react';
import { faCompassDrafting } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import SparkelIcon from '../icon/SparkelIcon';

export const SheetCalibrationButton = forwardRef<
  {
    hasCalibration: boolean;
  },
  'button'
>(({ hasCalibration, onClick }, ref) => {
  const { t } = useTranslation('project');

  if (hasCalibration) {
    return (
      <Tooltip label={t('viewer-interactions.recalibrate')}>
        <IconButton
          ref={ref}
          aria-label="Recalibrate"
          icon={<SparkelIcon icon={faCompassDrafting} />}
          isRound
          colorScheme="gray"
          variant="solid-no-transparent"
          size="xs"
          onClick={onClick}
        />
      </Tooltip>
    );
  } else {
    return (
      <Button
        ref={ref}
        aria-label="Calibrate"
        leftIcon={<SparkelIcon icon={faCompassDrafting} color={'white.300'} />}
        colorScheme="red"
        variant="solid-no-transparent"
        size="xs"
        onClick={onClick}
      >
        {t('viewer-interactions.calibrate')}
      </Button>
    );
  }
});
